import {
  createRouter,
  type RouteIds,
  RouteById as GenericRouteById,
  useRouter,
  useMatches,
} from '@tanstack/react-router';
import { type FileRoutesById, routeTree } from './routeTree.gen';

const NotFoundPage = () => {
  // Access router instance
  const router = useRouter();
  // Access current matches
  const matches = useMatches();

  console.log({ matches, state: router.state });
  return (
    <main>
      <h1>Page Not Found</h1>
      <p>The page you requested could not be found.</p>
      <div>
        <p>Current URL: {router.state.location.pathname}</p>
      </div>
    </main>
  );
};

export const router = createRouter({
  defaultNotFoundComponent: NotFoundPage,
  routeTree,
  defaultPreload: 'intent',
  context: {
    authenticated: false,
    user: undefined,
    lastLocationId: undefined,
  },
});

export type RouterType = typeof router;
export type RouterIds = RouteIds<RouterType['routeTree']>;
export type RouteById<T extends RouterIds> = GenericRouteById<RouterType['routeTree'], T>;
export type { FileRoutesById };
